<div *ngIf="loading" class="gw-py-8 gw-text-center gw-text-text-secondary">
  {{ 'common.loading' | translate }}
</div>

<div *ngIf="!loading && healthCheck" class="gw-space-y-6">
  <!-- Summary cards -->
  <div class="gw-grid gw-grid-cols-1 md:gw-grid-cols-3 gw-gap-4">
    <div
      class="gw-bg-background-elevation-2 gw-rounded-lg gw-p-4 gw-border-base"
    >
      <p class="gw-text-sm gw-text-text-secondary gw-mb-1">
        {{ 'features.pools.internalTotal' | translate }}
      </p>
      <p class="gw-text-xl gw-font-semibold gw-text-text-primary">
        {{
          healthCheck.internal.total
            | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
        }}
      </p>
      <p class="gw-text-xs gw-text-text-secondary gw-mt-2">
        {{ 'features.pools.available' | translate }}:
        {{
          healthCheck.internal.available
            | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
        }}
        · {{ 'features.pools.pending' | translate }}:
        {{
          healthCheck.internal.pending
            | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
        }}
      </p>
    </div>

    <div
      class="gw-bg-background-elevation-2 gw-rounded-lg gw-p-4 gw-border-base"
    >
      <p class="gw-text-sm gw-text-text-secondary gw-mb-1">
        {{ 'features.pools.providerBalance' | translate }}
        ({{ healthCheck.provider | provider }})
      </p>
      <p
        *ngIf="healthCheck.providerBalance as pb"
        class="gw-text-xl gw-font-semibold gw-text-text-primary"
      >
        {{ pb.total | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
      </p>
      <p
        *ngIf="!healthCheck.providerBalance"
        class="gw-text-sm gw-text-text-secondary"
      >
        {{
          healthCheck.providerError ||
            ('features.pools.providerUnavailable' | translate)
        }}
      </p>
      <span
        class="gw-inline-block gw-mt-2 gw-px-2 gw-py-1 gw-rounded-full gw-text-xs gw-font-medium"
        [ngClass]="providerStatusClass"
      >
        {{
          'features.pools.providerStatus.' + healthCheck.providerStatus
            | translate
        }}
      </span>
    </div>

    <div
      class="gw-bg-background-elevation-2 gw-rounded-lg gw-p-4 gw-border-base"
    >
      <p class="gw-text-sm gw-text-text-secondary gw-mb-1">
        {{ 'features.pools.reconciliation' | translate }}
      </p>
      <span
        *ngIf="healthCheck.reconciliation"
        class="gw-inline-block gw-px-3 gw-py-1 gw-rounded-full gw-text-sm gw-font-medium"
        [ngClass]="reconciliationClass"
      >
        {{
          healthCheck.reconciliation.isReconciled
            ? ('features.pools.reconciled' | translate)
            : ('features.pools.discrepancy' | translate)
        }}
      </span>
      <p
        *ngIf="healthCheck.reconciliation?.discrepancy as disc"
        class="gw-text-xs gw-text-text-secondary gw-mt-2"
      >
        {{ 'features.pools.discrepancyTotal' | translate }}:
        {{ disc.total | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
      </p>
      <p
        *ngIf="!healthCheck.reconciliation"
        class="gw-text-sm gw-text-text-secondary"
      >
        {{ 'features.pools.reconciliationUnavailable' | translate }}
      </p>
    </div>
  </div>

  <!-- Wallet breakdown -->
  <section class="gw-border-base gw-p-4 gw-bg-background-elevation-2">
    <h3 class="gw-text-lg gw-font-semibold gw-text-text-primary gw-mb-3">
      {{ 'features.pools.walletBreakdown' | translate }}
    </h3>
    <div
      class="gw-overflow-x-auto gw-rounded-lg gw-border gw-border-border-normal"
    >
      <table class="gw-w-full">
        <thead>
          <tr
            class="gw-border-b gw-border-border-normal gw-bg-background-neutral-2"
          >
            <th
              class="gw-text-left gw-px-4 gw-py-3 gw-text-sm gw-font-semibold"
            >
              {{ 'features.pools.columns.walletId' | translate }}
            </th>
            <th
              class="gw-text-left gw-px-4 gw-py-3 gw-text-sm gw-font-semibold"
            >
              {{ 'features.pools.columns.recipient' | translate }}
            </th>
            <th
              class="gw-text-left gw-px-4 gw-py-3 gw-text-sm gw-font-semibold"
            >
              {{ 'features.pools.columns.label' | translate }}
            </th>
            <th
              class="gw-text-right gw-px-4 gw-py-3 gw-text-sm gw-font-semibold"
            >
              {{ 'features.pools.available' | translate }}
            </th>
            <th
              class="gw-text-right gw-px-4 gw-py-3 gw-text-sm gw-font-semibold"
            >
              {{ 'features.pools.pending' | translate }}
            </th>
            <th
              class="gw-text-right gw-px-4 gw-py-3 gw-text-sm gw-font-semibold"
            >
              {{ 'features.pools.withheld' | translate }}
            </th>
            <th
              class="gw-text-right gw-px-4 gw-py-3 gw-text-sm gw-font-semibold"
            >
              {{ 'features.pools.total' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let w of healthCheck.wallets"
            class="gw-border-b gw-border-border-normal gw-bg-background-elevation-3 hover:gw-bg-background-neutral-2"
          >
            <td class="gw-px-4 gw-py-3">{{ w.walletId }}</td>
            <td class="gw-px-4 gw-py-3 gw-text-medium">
              {{ recipientName(w) || '—' }}
            </td>
            <td class="gw-px-4 gw-py-3">{{ walletLabel(w) || '—' }}</td>
            <td class="gw-px-4 gw-py-3 gw-text-right">
              {{
                w.available | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
              }}
            </td>
            <td class="gw-px-4 gw-py-3 gw-text-right">
              {{ w.pending | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
            </td>
            <td class="gw-px-4 gw-py-3 gw-text-right">
              {{ w.withheld | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
            </td>
            <td class="gw-px-4 gw-py-3 gw-text-right gw-font-medium">
              {{ w.total | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR' }}
            </td>
          </tr>
          <tr *ngIf="!healthCheck.wallets?.length">
            <td
              colspan="7"
              class="gw-px-4 gw-py-6 gw-text-center gw-text-text-secondary"
            >
              {{ 'features.pools.noWallets' | translate }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
